import FormattedCurrency from "./formatted-currency";
import pure from "./higher-order/pure";
import React from "react";
import { totalAlternatePrize } from "../payouts";

export default pure(function AlternateGameDetails({ tokenTypes, tournament }) {
  if (!tournament.get("alternate_active")) {
    return null;
  }

  var min = tournament.get("alternate_number_of_users_required");
  var max = tournament.get("alternate_max_users");
  var entriesMessage = ["between", min, "and", max].join(" ");
  if (min === max) {
    entriesMessage = "only " + min;
  }

  return (
    <dl className="tournament-table_meta_item">
      <dt>
        Alternate Game Info:
      </dt>

      <dt>
        If this game has
        {" "}

        {entriesMessage}

        {" "}
        entries, an alternate game will be created with the same races. The link will be provided at the top of this game page. All players &amp; picks will automatically be moved to the alternate game at the start of that tournament.
      </dt>

      <dd>
        <ul className="tournament-table_tracks-group">
          <li>
            <dl className="tournament-table_tracks">
              <dt>
                Alternate Game:
              </dt>

              <dd>
                {tournament.get("alternate_name")}
              </dd>
            </dl>
          </li>

          <li>
            <dl className="tournament-table_tracks">
              <dt>
                Prize Pool:
              </dt>

              <dd>
                <FormattedCurrency dollarsValue={totalAlternatePrize(tournament, tokenTypes)} />
              </dd>
            </dl>
          </li>

          <li>
            <dl className="tournament-table_tracks">
              <dt>
                Minimum entries for alternate:
              </dt>

              <dd>
                {min}
              </dd>
            </dl>
          </li>

          <li>
            <dl className="tournament-table_tracks">
              <dt>
                Maximum entries for alternate:
              </dt>

              <dd>
                {max}
              </dd>
            </dl>
          </li>
        </ul>
      </dd>
    </dl>
  );
});
